module.exports = {
  styleScope: 'access-management-style-scope',
};
